import React from 'react';
import { Box, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';

const LibraryModeBanner: React.FC = () => (
  <Box
    role="status"
    aria-label={COPY.libraryMode}
    sx={{
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      px: 2,
      py: 1,
      bgcolor: PRES.navy,
      color: PRES.white,
      borderBottom: `3px solid ${PRES.gold}`,
    }}
  >
    <Box
      sx={{
        flexShrink: 0,
        px: 1,
        py: 0.25,
        borderRadius: 0.75,
        bgcolor: PRES.gold,
        color: PRES.navyDeep,
        fontFamily: TYPE.ui,
        ...TYPE.label,
        fontWeight: 750,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
      }}
    >
      {COPY.libraryMode}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, fontWeight: 650, color: PRES.white }}>
        {COPY.libraryModeBanner}
      </Typography>
      <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.caption, color: 'rgba(255,255,255,0.78)' }}>
        {COPY.libraryModeHelp}
      </Typography>
    </Box>
  </Box>
);

export default LibraryModeBanner;
